var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['view-on-bandcamp']},[_c('a',{class:[((_vm.$config.colors.primary) + "--text")],attrs:{"href":_vm.href,"rel":"noreferrer","target":"_blank","title":_vm.$lang.viewOnBadcamp},domProps:{"innerHTML":_vm._s(_vm.$lang.viewOnBadcamp)}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-eb776cd6","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/view-on-bandcamp.vue
// module id = null
// module chunks = 